import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const ApplicationStatusEnum = z.enum([
  "PENDING",
  "APPLIED",
  "INTERVIEW_SCHEDULED",
  "INTERVIEW_COMPLETED",
  "OFFER_RECEIVED",
  "ACCEPTED",
  "REJECTED",
  "WITHDRAWN",
]);

export type ApplicationStatus = z.infer<typeof ApplicationStatusEnum>;

const DocumentLinkSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
});

export const JobApplicationSchema = z.object({
  id: z.string(),
  userId: z.string(),
  companyName: z.string(),
  jobTitle: z.string(),
  jobDescription: z.string().nullable(),
  jobUrl: z.string().nullable(),
  resumeId: z.string(),
  coverLetterId: z.string().nullable(),
  status: ApplicationStatusEnum,
  appliedAt: z.string().datetime(),
  reminderEnabled: z.boolean(),
  reminderDate: z.string().datetime().nullable(),
  followUpDate: z.string().datetime().nullable(),
  interviewDate: z.string().datetime().nullable(),
  notes: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  resume: DocumentLinkSchema.optional(),
  coverLetter: DocumentLinkSchema.optional().nullable(),
});

export class JobApplicationDto extends createZodDto(JobApplicationSchema) {}
